export default __webpack_public_path__ + "static/media/ep_location.d84a4136.svg";